<template>
  <v-container>
    <v-navigation-drawer id="app-drawer"
                         v-model="inputValue"
                         :src="image"
                         app
                         color="grey darken-2"
                         dark
                         floating
                         mobile-breakpoint="1323"
                         persistent
                         width="260">
      <template v-slot:img="attrs">
        <v-img v-bind="attrs"
               gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)" />
      </template>

      <a href="/">
        <v-list-item two-line>
          <v-img src="/dist/assets/adnami-final-logo_white.png" class="logo" contain />
      </v-list-item>
    </a>

    <v-divider class="mx-3 mb-3" />

    <v-list nav dense>
      <!-- Bug in Vuetify for first child of v-list not receiving proper border-radius -->
      <div />

      <span v-for="(link, i) in links">
        <v-list-group v-if="link.children && link.children.length > 0"
                      :key="i"
                      :to="link.path"
                      :prepend-icon="link.meta.icon">
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="link.name"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="child in link.children"
                       v-if="child.meta.displayInMenu"
                       :key="child.name"
                       :to="child.path"
                       @click="handleClick('')"
                       :prepend-icon="child.meta.icon"
                       active-class="primary white--text">
            <v-list-item-content>
              <v-list-item-title v-text="child.name"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
          <v-list-item v-else :key="i"
                       :to="link.path"
                       @click="handleClick(link.name)"
                       active-class="primary white--text">
            <v-list-item-action>
              <v-icon>{{ link.meta.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-title v-text="link.name" />
          </v-list-item>
        </span>
      </v-list>

      <template v-slot:append>
        <v-list dense nav v-if="!user">
          <div />
          <v-list-item @click="login()">
            <v-list-item-action>
              <v-icon>mdi-login-variant</v-icon>
            </v-list-item-action>

            <v-list-item-title class="font-weight-light">
              Login
            </v-list-item-title>
          </v-list-item>
        </v-list>
        <v-list dense nav v-else>
          <div />
          <v-list-item @click="openHelpCenter()">
            <v-list-item-action>
              <v-icon>mdi-help</v-icon>
            </v-list-item-action>

            <v-list-item-title class="font-weight-light">
              Help center
            </v-list-item-title>
          </v-list-item>
          <v-list-item :href="'mailto:support@adnami.io'">
            <v-list-item-action>
              <v-icon>mdi-contact-mail</v-icon>
            </v-list-item-action>

            <v-list-item-title class="font-weight-light">
              Contact support
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="logout()">
            <v-list-item-action>
              <v-icon>mdi-logout-variant</v-icon>
            </v-list-item-action>

            <v-list-item-title class="font-weight-light">
              Log out
            </v-list-item-title>
          </v-list-item>
        </v-list>
    </template>
  </v-navigation-drawer>
  </v-container>
</template>

<script>
  import { paths } from '../../router/routes'
  import { Dialog } from '@models'
  import { cid, container } from 'inversify-props';
  import IAuthService from '../../services/IAuthService';

  // Utilities
  import {
    mapMutations,
    mapState
  } from 'vuex'

  export default {
    props: {
      opened: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      links: [],
      paths: [],
      user: null,
      authService: null,
    }),

    created() {
      this.authService = container.get(cid.IAuthService);
      this.user = this.authService.getUser();
      this.paths = paths;

      var context = this;

      for (let i = 0; i < this.paths.length; i++) {
        if (this.paths[i].meta.displayInMenu) {
          this.authService.userHasRole(this.paths[i].meta.role).then((hasRole) => {
            if (hasRole) {
              context.links.push(context.paths[i]);
            }
          })
        }
      }

    },

    computed: {
      ...mapState('app', ['image', 'color']),
      inputValue: {
        get() {
          return this.$store.state.app.drawer
        },
        set(val) {
          this.setDrawer(val)
        }
      },
      items() {
        return this.$t('Layout.View.items')
      }
    },

    methods: {
      ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
      ...mapMutations('campaignListFilter', ['clearState']),

      login: function () {
        this.authService.login();
      },

      logout: function () {
        this.authService.logout()
      },

      openHelpCenter: function () {
        window.open("https://www.adnami.io/help");
      },

      handleClick: function (name) {
        this.clearState();
      }
    }
  }
</script>
<style lang="scss">
  .v-list {

    .v-list-item {
      color: #FFFFFF !important;

      &--active::before {
        opacity: 0 !important;
      }
    }
  }
</style>
